var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.0002C0 4.47798 4.47779 0.000198364 10 0.000198364C15.5229 0.000198364 20 4.47765 20 10.0002C20 15.5227 15.5229 20.0002 10 20.0002C4.47779 20.0002 0 15.5224 0 10.0002ZM18.5 10.0002C18.5 5.30605 14.6944 1.5002 10 1.5002C5.30621 1.5002 1.5 5.30641 1.5 10.0002C1.5 14.694 5.30621 18.5002 10 18.5002C14.6944 18.5002 18.5 14.6943 18.5 10.0002ZM9.9951 5.4543C10.3748 5.4543 10.6886 5.73645 10.7383 6.10253L10.7451 6.2043V10.6233C10.7451 11.0375 10.4093 11.3733 9.9951 11.3733C9.6154 11.3733 9.30161 11.0911 9.25195 10.7251L9.2451 10.6233V6.2043C9.2451 5.79008 9.58089 5.4543 9.9951 5.4543ZM10.7551 13.7961C10.7551 13.3819 10.4193 13.0461 10.0051 13.0461L9.89333 13.0529C9.52725 13.1026 9.2451 13.4164 9.2451 13.7961C9.2451 14.2103 9.58089 14.5461 9.9951 14.5461L10.1069 14.5393C10.4729 14.4896 10.7551 14.1758 10.7551 13.7961Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.a60a71c9.svg";
export { ForwardRef as ReactComponent };